import baseService from './baseService.js';

export function getDefaultValues(organizationId) {
  return baseService.get(`/organizations/${organizationId}/default_values/`);
}
